import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SwipeableRowActionAlignConstantType,
    SwipeableRowActionDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getOpaqueColor,
    webStyle
} from "../../../../utils";

export const getSwipeableRowActionAlign = ({
    isFirst,
    isFull,
    side
}: SwipeableRowActionAlignConstantType): SwipeableRowActionDynamicStyleType["contentAlign"] => {
    if(!isFull || !isFirst) {
        return "center";
    }

    return side === "trailing" ? "flex-start" : "flex-end";
};

const stylesheet = StyleSheet.create({
    container: {
        overflow: "hidden",
        flexBasis: 0,
        flexGrow: 1,
        minWidth: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        flexGrow: 1
    },
    content: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    label: {
        textAlign: "center",
        maxWidth: "100%"
    }
});

export const useStyles = ({
    isFocusVisible,
    currentColors,
    contentAlign,
    isCollapsed,
    colorKey,
    borders,
    colors,
    spaces,
    width
}: SwipeableRowActionDynamicStyleType) => {
    // A panel under the sliding row: its tonal fill stays solid and as heavy as the coloured actions beside it.
    const styles = {
        surface: {
            backgroundColor: getOpaqueColor({
                surface: colors.content.container.default,
                color: currentColors.containerColor
            }),
            alignItems: contentAlign
        } as Mutable<ViewStyle>,
        container: {} as Mutable<ViewStyle>,
        content: {
            gap: spaces.spacingXs,
            width
        } as Mutable<ViewStyle>
    };

    if(isCollapsed) {
        styles.container.flexGrow = 0;
    }

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        isInset: true,
        colorKey,
        borders,
        colors
    }));

    if(isFocusVisible) {
        styles.surface.boxShadow = [
            {
                color: colors.content.container.raised,
                spreadDistance: borders.focus * 2,
                offsetX: 0,
                offsetY: 0,
                inset: true
            }
        ];
    }

    return styles;
};
export default stylesheet;
